  // Centralized backend URL — set via theme.liquid bridge (window.KZ_BACKENDS).
  var COMPARADOR_BASE = (window.KZ_BACKENDS && window.KZ_BACKENDS.comparador) || 'https://comparador-backend.vercel.app';

  document.addEventListener("DOMContentLoaded", function () {
    var modal = document.getElementById("modalComparador");
    var fecharBtn = document.getElementById("fecharModal");
    var steps = document.querySelectorAll(".step");
    var stepContents = document.querySelectorAll(".step-content");
    var currentStep = 1;

    var produtoA = document.getElementById("produtoA");
    var produtoB = document.getElementById("produtoB");
    var pesquisaA = document.getElementById("pesquisaA");
    var pesquisaB = document.getElementById("pesquisaB");
    var previewA = document.getElementById("previewA");
    var previewB = document.getElementById("previewB");
    var bodyDropdownA = document.getElementById("bodyDropdownA");
    var bodyDropdownB = document.getElementById("bodyDropdownB");
    var dropdownParents = [bodyDropdownA.parentNode, bodyDropdownB.parentNode];
    var avancarStep1 = document.getElementById("avancar-step-1");
    var voltarStep2 = document.getElementById("voltar-step-2");
    var avancarStep2 = document.getElementById("avancar-step-2");
    var voltarStep3 = document.getElementById("voltar-step-3");
    var novaComparacao = document.getElementById("nova-comparacao");

    var comparadorConfig = readComparatorConfig();
    var sectionId = comparadorConfig.sectionId || "comparador-products-data";
    var collectionHandles = comparadorConfig.collections || [
      "fones-kz",
      "fones-qkz",
      "fones-cca",
      "fones-bluetooth-kz",
      "adaptadores-bluetooth",
      "gamer"
    ];
    var currentProductData = comparadorConfig.currentProduct || null;
    var allOptions = Array.from(produtoA.options);
    var productById = {};
    var collectionStates = {};
    var collectionPromises = {};
    var catalogExpiresAt = 0;
    var catalogGeneration = 0;
    var selectedCategory = "";
    var selectedCollections = [];
    var debounceTimer = null;
    var fetchController = null; // AbortController para cancelar fetch ao fechar modal
    var lastFocusedBeforeOpen = null; // Restored on close so keyboard users don't lose context
    var loadingProductsText = "Carregando produtos...";
    var modalGeneration = 0;
    var comparisonGeneration = 0;
    var stopComparison = null;
    var scrollLockState = null;
    var catalogErrorText = "Não foi possível carregar os produtos. Feche e abra o comparador para tentar novamente.";

    function readComparatorConfig() {
      var configEl = document.getElementById("comparador-config-data");
      if (!configEl) return {};

      try {
        return JSON.parse(configEl.textContent) || {};
      } catch (err) {
        return {};
      }
    }

    function getShopifyRoot() {
      var root = "/";
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        root = window.Shopify.routes.root;
      }
      return root.charAt(root.length - 1) === "/" ? root : root + "/";
    }

    function normalizeProduct(rawProduct, collectionHandle) {
      if (!rawProduct || rawProduct.id == null) return null;

      var handle = rawProduct.handle || "";
      var productUrl = rawProduct.url || (handle ? getShopifyRoot() + "products/" + handle : "#");

      return {
        id: String(rawProduct.id),
        title: rawProduct.title || "",
        handle: handle,
        description: rawProduct.description || "",
        image: rawProduct.image || rawProduct.featured_image || "",
        price: rawProduct.price || "",
        priceMinorUnits: rawProduct.priceMinorUnits,
        currency: rawProduct.currency || "",
        collections: Array.from(new Set((rawProduct.collections || []).concat([collectionHandle, rawProduct.category, rawProduct.collection]).filter(Boolean))),
        url: productUrl,
        category: rawProduct.category || rawProduct.collection || collectionHandle || ""
      };
    }

    function findOption(selectEl, productId) {
      if (!selectEl) return null;

      for (var i = 0; i < selectEl.options.length; i++) {
        if (selectEl.options[i].value === String(productId)) {
          return selectEl.options[i];
        }
      }

      return null;
    }

    function setOptionData(option, product) {
      option.value = product.id;
      option.textContent = product.title;
      option.setAttribute("data-description", product.description || "");
      option.setAttribute("data-image", product.image || "");
      option.setAttribute("data-price", product.price || "");
      option.setAttribute("data-price-minor-units", Number.isSafeInteger(product.priceMinorUnits) ? String(product.priceMinorUnits) : "");
      option.setAttribute("data-currency", product.currency || "");
      option.setAttribute("data-collections", JSON.stringify(product.collections || []));
      option.setAttribute("data-product-url", product.url || "#");
      option.setAttribute("data-category", product.category || "");
      option.setAttribute("data-handle", product.handle || "");
    }

    function syncProductOption(selectEl, product) {
      if (!selectEl || !product || !product.id) return;

      var option = findOption(selectEl, product.id);
      if (!option) {
        option = document.createElement("option");
        selectEl.appendChild(option);
      }

      setOptionData(option, product);
    }

    function upsertProduct(product) {
      if (!product || !product.id) return null;

      var existing = productById[product.id];
      if (existing) {
        existing.collections = Array.from(new Set(existing.collections.concat(product.collections))).sort();
        if (existing.priceMinorUnits == null) existing.priceMinorUnits = product.priceMinorUnits;
        if (!existing.currency) existing.currency = product.currency;
        if (!existing.description && product.description) existing.description = product.description;
        if (!existing.image && product.image) existing.image = product.image;
        if (!existing.price && product.price) existing.price = product.price;
        if (!existing.url && product.url) existing.url = product.url;
        if (!existing.handle && product.handle) existing.handle = product.handle;
        if (!existing.category && product.category) existing.category = product.category;
        product = existing;
      } else {
        productById[product.id] = product;
      }

      syncProductOption(produtoA, product);
      syncProductOption(produtoB, product);
      allOptions = Array.from(produtoA.options);
      return product;
    }

    function getProductsForCollection(collectionHandle) {
      var products = [];

      Object.keys(productById).forEach(function (productId) {
        var product = productById[productId];
        if (product.collections.indexOf(collectionHandle) !== -1) {
          products.push(product);
        }
      });

      return products;
    }

    function getCollectionCacheKey(collectionHandle) {
      return [
        "kzComparadorProductsBR",
        "v2",
        getShopifyRoot(),
        (window.Shopify && window.Shopify.locale) || "",
        comparadorConfig.country || "",
        comparadorConfig.currency || "",
        sectionId,
        collectionHandle
      ].join(":");
    }

    function readCachedCollection(collectionHandle) {
      try {
        var raw = window.sessionStorage && sessionStorage.getItem(getCollectionCacheKey(collectionHandle));
        if (!raw) return null;

        var payload = JSON.parse(raw);
        if (!payload || !Array.isArray(payload.products) || !Number.isFinite(payload.savedAt) || Date.now() - payload.savedAt >= 300000 || payload.savedAt > Date.now()) return null;
        catalogExpiresAt = Math.min(catalogExpiresAt, payload.savedAt + 300000);
        return payload.products;
      } catch (err) {
        return null;
      }
    }

    function writeCachedCollection(collectionHandle, products) {
      try {
        if (!window.sessionStorage) return;
        sessionStorage.setItem(
          getCollectionCacheKey(collectionHandle),
          JSON.stringify({ products: products || [], savedAt: Date.now() })
        );
      } catch (err) {
        // Ignore storage quota/private-mode failures.
      }
    }

    function parseCollectionPayload(html) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      var dataEl = doc.querySelector("[data-comparador-products-json]");

      if (!dataEl) {
        throw new Error("Comparator product payload not found.");
      }

      return JSON.parse(dataEl.textContent);
    }

    function fetchCollectionPage(collectionHandle, page) {
      var url = getShopifyRoot() +
        "collections/" +
        encodeURIComponent(collectionHandle) +
        "?section_id=" +
        encodeURIComponent(sectionId) +
        "&page=" +
        encodeURIComponent(page);

      return fetch(url, { credentials: "same-origin", signal: AbortSignal.timeout(30000) }).then(function (response) {
        if (!response.ok) {
          throw new Error("HTTP " + response.status);
        }

        return response.text();
      }).then(parseCollectionPayload);
    }

    function loadCollection(collectionHandle) {
      if (!collectionHandle) return Promise.resolve([]);

      if (collectionStates[collectionHandle] === "loaded") {
        return Promise.resolve(getProductsForCollection(collectionHandle));
      }

      if (collectionPromises[collectionHandle]) {
        return collectionPromises[collectionHandle];
      }

      var cachedProducts = readCachedCollection(collectionHandle);
      if (cachedProducts) {
        cachedProducts.forEach(function (product) {
          upsertProduct(normalizeProduct(product, collectionHandle));
        });
        collectionStates[collectionHandle] = "loaded";
        return Promise.resolve(cachedProducts);
      }

      var generation = catalogGeneration;
      collectionStates[collectionHandle] = "loading";
      collectionPromises[collectionHandle] = fetchCollectionPage(collectionHandle, 1)
        .then(function (firstPayload) {
          if (generation !== catalogGeneration) return [];
          var products = firstPayload.products || [];
          var pages = parseInt(firstPayload.pages, 10) || 1;
          var pageFetches = [];

          for (var page = 2; page <= pages; page++) {
            pageFetches.push(fetchCollectionPage(collectionHandle, page));
          }

          return Promise.all(pageFetches).then(function (payloads) {
            if (generation !== catalogGeneration) return [];
            payloads.forEach(function (payload) {
              products = products.concat(payload.products || []);
            });

            products.forEach(function (product) {
              upsertProduct(normalizeProduct(product, collectionHandle));
            });

            collectionStates[collectionHandle] = "loaded";
            writeCachedCollection(collectionHandle, products);
            return products;
          });
        })
        .catch(function (err) {
          if (generation !== catalogGeneration) return [];
          collectionStates[collectionHandle] = "error";
          delete collectionPromises[collectionHandle];
          throw err;
        });

      return collectionPromises[collectionHandle];
    }

    function getCollectionsForInput(input) {
      if (input === pesquisaB && selectedCollections.length) {
        return selectedCollections;
      }

      return collectionHandles;
    }

    function areCollectionsSettled(handles) {
      for (var i = 0; i < handles.length; i++) {
        if (collectionStates[handles[i]] !== "loaded" && collectionStates[handles[i]] !== "error") {
          return false;
        }
      }

      return true;
    }

    function ensureCollectionsLoaded(handles) {
      return Promise.all(handles.map(function (collectionHandle) {
        return loadCollection(collectionHandle).catch(function () {
          return null;
        });
      }));
    }

    function renderSuggestionMessage(input, dropdownContainer, message) {
      while (dropdownContainer.firstChild) {
        dropdownContainer.removeChild(dropdownContainer.firstChild);
      }

      var dropdown = document.createElement("div");
      dropdown.className = "suggestions-dropdown";

      var item = document.createElement("div");
      item.className = "suggestion-item";
      item.setAttribute("role", "option");
      item.setAttribute("aria-selected", "false");
      item.textContent = message;

      dropdown.appendChild(item);
      dropdownContainer.appendChild(dropdown);
      positionDropdown(input, dropdownContainer);
      dropdownContainer.style.display = "block";
      input.setAttribute("aria-expanded", "true");
    }

    function seedCurrentProduct(productData) {
      var product = normalizeProduct(productData, productData && productData.category);
      if (!product || !product.category) return;

      upsertProduct(product);
      produtoA.value = product.id;
      pesquisaA.value = product.title;
      selectedCategory = product.category;
      selectedCollections = product.collections;

      var changeEvent = new Event("change");
      produtoA.dispatchEvent(changeEvent);
      setButtonEnabled(avancarStep1, produtoA.value);
    }

    function loadInitialCatalog() {
      if (selectedCategory) {
        ensureCollectionsLoaded([selectedCategory]);
      }

      return ensureCollectionsLoaded(collectionHandles);
    }

    function refreshExpiredCatalog() {
      var expired = catalogExpiresAt && Date.now() >= catalogExpiresAt;
      if (expired) {
        catalogGeneration++;
        productById = {};
        collectionStates = {};
        collectionPromises = {};
        produtoA.options.length = 1;
        produtoB.options.length = 1;
        allOptions = Array.from(produtoA.options);
        bodyDropdownA.textContent = "";
        bodyDropdownB.textContent = "";
      }
      if (!catalogExpiresAt || expired) catalogExpiresAt = Date.now() + 300000;
    }

    function stripHtml(html) {
      if (!html) return "";

      var div = document.createElement("div");
      div.innerHTML = html;
      return (div.textContent || div.innerText || "").trim();
    }

    function fetchProductDescription(option, signal) {
      var currentDescription = option.getAttribute("data-description");
      if (currentDescription) return Promise.resolve(currentDescription);

      var handle = option.getAttribute("data-handle");
      if (!handle) return Promise.resolve("");

      var url = getShopifyRoot() + "products/" + encodeURIComponent(handle) + ".js";

      return fetch(url, { credentials: "same-origin", signal: signal })
        .then(function (response) {
          if (!response.ok) {
            throw new Error("HTTP " + response.status);
          }

          return response.json();
        })
        .then(function (product) {
          if (signal && signal.aborted) return "";
          var description = stripHtml(product.description || product.body_html || "");
          option.setAttribute("data-description", description);

          var productId = option.value;
          if (productById[productId]) {
            productById[productId].description = description;
          }

          return description;
        });
    }

    // Hide broken product images instead of showing the alt text + browser's
    // missing-image icon (still rare but happens when a product gets its
    // featured_image removed mid-session).
    function hideOnImageError(img) {
      if (!img) return;
      img.addEventListener("error", function () { this.style.visibility = "hidden"; });
      img.addEventListener("load", function () { this.style.visibility = ""; });
    }
    ["imgA", "imgB", "summaryImgA", "summaryImgB"].forEach(function (id) {
      hideOnImageError(document.getElementById(id));
    });

    // === Utilidades ===

    function setButtonEnabled(button, value) {
      button.disabled = !value;
    }

    // === Scroll Lock ===

    var touchStartY = 0;

    function getScrollable(target) {
      var node = target.closest(".body-dropdown-container");
      if (!node || node.scrollHeight <= node.clientHeight) node = target.closest(".modal-corpo");
      if (!node || node.scrollHeight <= node.clientHeight) return null;
      return node;
    }

    function canScroll(node, deltaY) {
      if (!node) return false;
      if (deltaY < 0) return node.scrollTop > 0;
      if (deltaY > 0) return node.scrollTop + node.clientHeight < node.scrollHeight - 1;
      return true;
    }

    modal.addEventListener("wheel", function (event) {
      if (!modal.classList.contains("aberto")) return;
      if (!canScroll(getScrollable(event.target), event.deltaY)) event.preventDefault();
    }, { passive: false });

    modal.addEventListener("touchstart", function (event) {
      if (event.touches && event.touches.length) touchStartY = event.touches[0].clientY;
    }, { passive: true });

    modal.addEventListener("touchmove", function (event) {
      if (!modal.classList.contains("aberto") || !event.touches || !event.touches.length) return;
      var deltaY = touchStartY - event.touches[0].clientY;
      if (!canScroll(getScrollable(event.target), deltaY)) event.preventDefault();
    }, { passive: false });

    function lockScroll() {
      if (scrollLockState) return;
      scrollLockState = {
        bodyStyle: document.body.getAttribute("style"),
        htmlStyle: document.documentElement.getAttribute("style"),
        bodyClass: document.body.classList.contains("modal-aberto"),
        htmlClass: document.documentElement.classList.contains("modal-aberto"),
        x: window.scrollX,
        y: window.scrollY
      };
      document.documentElement.classList.add("modal-aberto");
      document.body.classList.add("modal-aberto");
      document.body.style.position = "fixed";
      document.body.style.top = -scrollLockState.y + "px";
      document.body.style.left = -scrollLockState.x + "px";
      document.body.style.width = "100%";
    }

    function unlockScroll() {
      if (!scrollLockState) return;
      var state = scrollLockState;
      scrollLockState = null;
      if (state.bodyStyle === null) document.body.removeAttribute("style");
      else document.body.setAttribute("style", state.bodyStyle);
      if (state.htmlStyle === null) document.documentElement.removeAttribute("style");
      else document.documentElement.setAttribute("style", state.htmlStyle);
      document.documentElement.classList.toggle("modal-aberto", state.htmlClass);
      document.body.classList.toggle("modal-aberto", state.bodyClass);
      window.scrollTo(state.x, state.y);
    }

    // === Modal ===

    function fecharModal() {
      modal.classList.remove("aberto");
      unlockScroll();
      bodyDropdownA.style.display = "none";
      bodyDropdownB.style.display = "none";
      pesquisaA.setAttribute("aria-expanded", "false");
      pesquisaB.setAttribute("aria-expanded", "false");
      pesquisaA.removeAttribute("aria-activedescendant");
      pesquisaB.removeAttribute("aria-activedescendant");
      if (fetchController) {
        fetchController.abort();
        fetchController = null;
      }
      resetForm();
      // Return focus to whatever opened the modal (button, link, etc.) so
      // keyboard users don't lose their position in the page.
      if (lastFocusedBeforeOpen && typeof lastFocusedBeforeOpen.focus === "function") {
        try { lastFocusedBeforeOpen.focus({ preventScroll: true }); } catch (e) { /* element may have detached */ }
      }
      lastFocusedBeforeOpen = null;
    }

    function goToStep(step) {
      currentStep = step;

      steps.forEach(function (stepEl) {
        var stepNum = parseInt(stepEl.dataset.step, 10);
        stepEl.classList.remove("active", "completed");
        stepEl.removeAttribute("aria-current");
        if (stepNum === currentStep) {
          stepEl.classList.add("active");
          stepEl.setAttribute("aria-current", "step");
        } else if (stepNum < currentStep) {
          stepEl.classList.add("completed");
        }
      });

      document.querySelectorAll(".step-line").forEach(function (line, index) {
        line.classList.toggle("completed", index < currentStep - 1);
      });

      stepContents.forEach(function (content) {
        content.style.display = "none";
      });

      document.getElementById("step-" + currentStep).style.display = "block";
      bodyDropdownA.style.display = "none";
      bodyDropdownB.style.display = "none";
      pesquisaA.setAttribute("aria-expanded", "false");
      pesquisaB.setAttribute("aria-expanded", "false");
      pesquisaA.removeAttribute("aria-activedescendant");
      pesquisaB.removeAttribute("aria-activedescendant");
      if (modal.classList.contains("aberto")) {
        var focusTarget = currentStep === 1 ? pesquisaA : currentStep === 2 ? pesquisaB : document.querySelector("#step-3 .step-title");
        if (currentStep === 3) focusTarget.setAttribute("tabindex", "-1");
        focusTarget.focus({ preventScroll: true });
      }
    }

    function resetForm() {
      modalGeneration++;
      comparisonGeneration++;
      clearTimeout(debounceTimer);
      if (stopComparison) stopComparison();
      if (fetchController) fetchController.abort();
      fetchController = null;
      produtoA.value = "";
      produtoB.value = "";
      pesquisaA.value = "";
      pesquisaB.value = "";
      previewA.style.display = "none";
      previewB.style.display = "none";
      document.getElementById("resultado").textContent = "";
      avancarStep1.disabled = true;
      avancarStep2.disabled = true;
      bodyDropdownA.style.display = "none";
      bodyDropdownB.style.display = "none";
      pesquisaA.setAttribute("aria-expanded", "false");
      pesquisaB.setAttribute("aria-expanded", "false");
      pesquisaA.removeAttribute("aria-activedescendant");
      pesquisaB.removeAttribute("aria-activedescendant");
      selectedCategory = "";
      selectedCollections = [];
    }

    // === Dropdowns ===

    function isLocalDropdownLayout() {
      return window.matchMedia("(max-width: 768px), (pointer: coarse)").matches;
    }

    function positionDropdown(input, dropdown) {
      var local = isLocalDropdownLayout();
      var parent = local ? input.parentNode : dropdownParents[input === pesquisaA ? 0 : 1];
      if (dropdown.parentNode !== parent) parent.appendChild(dropdown);
      if (local) {
        ["top", "bottom", "left", "width", "overflow-y"].forEach(function (property) {
          dropdown.style.removeProperty(property);
        });
        // Calibrate capacity to the fixed frame; normal flow anchors below input.
        var viewport = window.visualViewport;
        var visibleBottom = viewport ? Math.max(0, modal.getBoundingClientRect().top + viewport.offsetTop) + viewport.height : document.documentElement.clientHeight;
        dropdown.style.maxHeight = Math.max(0, Math.min(240, visibleBottom - input.getBoundingClientRect().bottom - 28)) + "px";
        return;
      }
      var rect = input.getBoundingClientRect();
      var viewport = window.visualViewport;
      var viewportTop = viewport ? viewport.offsetTop : 0;
      var viewportBottom = viewportTop + (viewport ? viewport.height : window.innerHeight);
      var below = Math.max(0, viewportBottom - rect.bottom - 20);
      var above = Math.max(0, rect.top - viewportTop - 20);
      var openAbove = below < 120 && above > below;
      dropdown.style.top = openAbove ? "auto" : rect.bottom + "px";
      dropdown.style.bottom = openAbove ? document.documentElement.clientHeight - rect.top + "px" : "auto";
      dropdown.style.left = rect.left + "px";
      dropdown.style.width = rect.width + "px";
      dropdown.style.maxHeight = (openAbove ? above : below) + "px";
      dropdown.style.overflowY = "auto";
    }

    function hideDropdown(input, dropdownContainer) {
      clearTimeout(debounceTimer);
      dropdownContainer.style.display = "none";
      input.setAttribute("aria-expanded", "false");
      input.removeAttribute("aria-activedescendant");
    }

    function showSuggestions(input, dropdownContainer, excludeValue) {
      if (!modal.classList.contains("aberto") || document.activeElement !== input) return;
      var generation = modalGeneration;
      var query = input.value.toLowerCase();
      var neededCollections = getCollectionsForInput(input);

      if (!areCollectionsSettled(neededCollections)) {
        renderSuggestionMessage(input, dropdownContainer, loadingProductsText);
        ensureCollectionsLoaded(neededCollections).then(function () {
          if (generation === modalGeneration && modal.classList.contains("aberto") && document.activeElement === input && dropdownContainer.style.display === "block") {
            showSuggestions(input, dropdownContainer, input === pesquisaA ? produtoB.value : produtoA.value);
          }
        });
        return;
      }

      if (neededCollections.some(function (handle) { return collectionStates[handle] === "error"; })) {
        renderSuggestionMessage(input, dropdownContainer, catalogErrorText);
        return;
      }

      while (dropdownContainer.firstChild) {
        dropdownContainer.removeChild(dropdownContainer.firstChild);
      }

      var dropdown = document.createElement("div");
      dropdown.className = "suggestions-dropdown";
      dropdownContainer.appendChild(dropdown);

      var hasResults = false;
      var idPrefix = dropdownContainer.id + "_opt_";
      var itemIndex = 0;

      var filteredOptions =
        input === pesquisaB && selectedCollections.length
          ? allOptions.filter(function (opt) {
              var product = productById[opt.value];
              return product && product.collections.some(function (handle) { return selectedCollections.indexOf(handle) !== -1; });
            })
          : allOptions;
      filteredOptions = filteredOptions.slice().sort(function (a, b) {
        return a.text.localeCompare(b.text, "pt-BR") || a.value.localeCompare(b.value);
      });

      filteredOptions.forEach(function (option) {
        if (
          option.value &&
          option.value !== excludeValue &&
          (query.length === 0 || option.text.toLowerCase().includes(query))
        ) {
          hasResults = true;

          var item = document.createElement("div");
          item.className = "suggestion-item";
          // ARIA: each suggestion is an "option" inside the listbox so
          // assistive tech reads it correctly when keyboard-navigating.
          item.id = idPrefix + (itemIndex++);
          item.setAttribute("role", "option");
          item.setAttribute("aria-selected", "false");

          var img = document.createElement("img");
          img.src = option.getAttribute("data-image");
          img.alt = option.text;
          img.loading = "lazy";
          hideOnImageError(img);
          item.appendChild(img);

          var textDiv = document.createElement("div");
          textDiv.className = "suggestion-item-text";
          textDiv.textContent = option.text;
          item.appendChild(textDiv);

          item.dataset.value = option.value;
          item.dataset.image = option.getAttribute("data-image");
          item.dataset.description = option.getAttribute("data-description");
          item.dataset.text = option.text;
          item.dataset.price = option.getAttribute("data-price");
          item.dataset.productUrl = option.getAttribute("data-product-url");
          item.dataset.category = option.getAttribute("data-category");

          item.addEventListener("click", function () {
            var selectEl = input === pesquisaA ? produtoA : produtoB;
            selectEl.value = this.dataset.value;
            input.value = this.dataset.text;

            if (input === pesquisaA) {
              selectedCategory = this.dataset.category;
              produtoB.value = "";
              pesquisaB.value = "";
              previewB.style.display = "none";
              setButtonEnabled(avancarStep2, false);
            }

            var changeEvent = new Event("change");
            selectEl.dispatchEvent(changeEvent);

            if (input === pesquisaA) {
              setButtonEnabled(avancarStep1, produtoA.value);
            } else {
              setButtonEnabled(avancarStep2, produtoB.value);
            }

            hideDropdown(pesquisaA, bodyDropdownA);
            hideDropdown(pesquisaB, bodyDropdownB);
          });

          dropdown.appendChild(item);
        }
      });

      if (hasResults) {
        positionDropdown(input, dropdownContainer);
        dropdownContainer.style.display = "block";
        input.setAttribute("aria-expanded", "true");
      } else {
        hideDropdown(input, dropdownContainer);
      }
    }

    // Move the active-item highlight in a dropdown by `direction` (-1/+1).
    // Sets aria-activedescendant on the input so assistive tech announces
    // the currently-highlighted option without moving DOM focus away from
    // the input (combobox WAI-ARIA pattern).
    function moveActiveItem(input, dropdownContainer, direction) {
      var dropdown = dropdownContainer.querySelector(".suggestions-dropdown");
      if (!dropdown) return null;
      var items = dropdown.querySelectorAll(".suggestion-item");
      if (!items.length) return null;
      var current = dropdown.querySelector(".suggestion-item--active");
      var idx = current ? Array.prototype.indexOf.call(items, current) : -1;
      if (direction > 0) idx = idx < items.length - 1 ? idx + 1 : 0;
      else idx = idx > 0 ? idx - 1 : items.length - 1;
      for (var i = 0; i < items.length; i++) {
        var on = i === idx;
        items[i].classList.toggle("suggestion-item--active", on);
        items[i].setAttribute("aria-selected", on ? "true" : "false");
      }
      var active = items[idx];
      input.setAttribute("aria-activedescendant", active.id);
      // Keep the highlighted item visible inside the dropdown's own scroll.
      active.scrollIntoView({ block: "nearest" });
      return active;
    }

    // Keyboard navigation for the search inputs (combobox pattern):
    //   ArrowDown — move highlight down (or open dropdown if closed)
    //   ArrowUp   — move highlight up
    //   Enter     — select highlighted item (triggers click handler)
    //   Escape    — close dropdown
    function makeSearchKeydownHandler(input, dropdownContainer, getExclude) {
      return function (event) {
        var isOpen = dropdownContainer.style.display === "block";
        switch (event.key) {
          case "ArrowDown":
            event.preventDefault();
            if (!isOpen) {
              showSuggestions(input, dropdownContainer, getExclude());
              moveActiveItem(input, dropdownContainer, +1);
            } else {
              moveActiveItem(input, dropdownContainer, +1);
            }
            break;
          case "ArrowUp":
            if (!isOpen) return;
            event.preventDefault();
            moveActiveItem(input, dropdownContainer, -1);
            break;
          case "Enter":
            if (!isOpen) return;
            var active = dropdownContainer.querySelector(".suggestion-item--active");
            if (active) {
              event.preventDefault();
              active.click();
            }
            break;
          case "Escape":
            if (!isOpen) return;
            event.preventDefault();
            event.stopPropagation();
            hideDropdown(input, dropdownContainer);
            break;
        }
      };
    }

    function debouncedShowSuggestions(input, dropdownContainer, excludeValue) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        showSuggestions(input, dropdownContainer, excludeValue);
      }, 150);
    }

    // === Abrir Modal ===
    // Triggered via event delegation on [data-comparador-trigger] (see
    // bottom of this file) so we don't pollute window with a global
    // function and don't depend on inline onclick handlers.

    function abrirModal(trigger) {
      // Remember the trigger element so we can return focus to it on close
      // (WCAG 2.4.3 — focus must not get lost when a dialog dismisses).
      lastFocusedBeforeOpen = trigger || document.activeElement;
      lockScroll();
      modal.classList.add("aberto");
      goToStep(1);
      resetForm();
      refreshExpiredCatalog();
      var generation = modalGeneration;
      var currentProductId = currentProductData && String(currentProductData.id);
      seedCurrentProduct(catalogGeneration ? productById[currentProductId] : currentProductData);
      loadInitialCatalog().then(function () {
        if (catalogGeneration && generation === modalGeneration && modal.classList.contains("aberto") && currentStep === 1 && !produtoA.value && !pesquisaA.value) {
          seedCurrentProduct(productById[currentProductId]);
        }
      });
      setTimeout(function () {
        if (generation === modalGeneration && currentStep === 1 && modal.classList.contains("aberto")) pesquisaA.focus();
      }, 100);
    }

    // Event delegation for any trigger marked with data-comparador-trigger.
    // Replaces the previous onclick="abrirModal()" inline handlers and
    // window.abrirModal global, and works for triggers added to the DOM
    // dynamically (e.g., section editor live preview).
    document.addEventListener("click", function (e) {
      var trigger = e.target.closest("[data-comparador-trigger]");
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      abrirModal(trigger);
    });

    // === Comparação ===

    function buildComparisonDOM(text) {
      var container = document.createElement("div");
      container.className = "comparison-text";

      if (!text) return container;

      var lines = text.split("\n");
      var currentItemDiv = null;
      var currentContentDiv = null;

      for (var i = 0; i < lines.length; i++) {
        var line = lines[i].trim();
        if (!line) continue;

        var headerMatch = line.match(/^###\s+(.*)$/);
        if (headerMatch) {
          var h3 = document.createElement("h3");
          h3.textContent = headerMatch[1];
          container.appendChild(h3);
          continue;
        }

        var itemMatch = line.match(/^(\d+)\.\s+\*\*([^*]+):\*\*\s*(.*)$/) ||
          line.match(/^(\d+)\.\s+(.*?)(?:\s*:\s*(.*))?$/);
        if (itemMatch) {
          currentItemDiv = document.createElement("div");
          currentItemDiv.className = "comparison-item";

          var numberSpan = document.createElement("span");
          numberSpan.className = "item-number";
          numberSpan.textContent = itemMatch[1] + ".";
          currentItemDiv.appendChild(numberSpan);

          var titleSpan = document.createElement("span");
          titleSpan.className = "category-title";
          appendRichText(titleSpan, itemMatch[2]);
          currentItemDiv.appendChild(titleSpan);

          currentContentDiv = document.createElement("div");
          currentContentDiv.className = "comparison-content";
          if (itemMatch[3]) {
            appendRichText(currentContentDiv, itemMatch[3]);
          }
          currentItemDiv.appendChild(currentContentDiv);
          container.appendChild(currentItemDiv);
          continue;
        }

        if (line.startsWith("-")) {
          var subItem = document.createElement("div");
          subItem.className = "sublist-item";
          appendRichText(subItem, line.substring(1).trim());
          if (currentContentDiv) {
            currentContentDiv.appendChild(subItem);
          } else {
            container.appendChild(subItem);
          }
          continue;
        }

        if (currentContentDiv) {
          appendRichText(currentContentDiv, " " + line);
        } else {
          var p = document.createElement("p");
          appendRichText(p, line);
          container.appendChild(p);
        }
      }

      return container;
    }

    // Renders text with markdown-style emphasis safely (no innerHTML).
    // Handles BOTH **bold** and *italic* — the AI is inconsistent and uses
    // either form to emphasize product names like *KZ Phantom* or
    // **Especificações**. Order in the regex matters: the bold alternative
    // is listed first so it wins at positions where both could match.
    // [^*]+ excludes asterisks inside the emphasis run, preventing **foo**
    // from being mis-parsed as the italic *foo*.
    function appendRichText(parent, text) {
      var parts = text.split(/(\*\*[^*]+\*\*|\*[^*]+\*)/g);
      for (var i = 0; i < parts.length; i++) {
        var part = parts[i];
        if (part.length >= 4 && part.startsWith("**") && part.endsWith("**")) {
          var strong = document.createElement("strong");
          strong.textContent = part.slice(2, -2);
          parent.appendChild(strong);
        } else if (part.length >= 3 && part.startsWith("*") && part.endsWith("*")) {
          var em = document.createElement("em");
          em.textContent = part.slice(1, -1);
          parent.appendChild(em);
        } else {
          parent.appendChild(document.createTextNode(part));
        }
      }
    }

    // In-modal error banner — replaces alert() so users stay in the flow
    // (alert blocks the page and looks unprofessional in 2026).
    function showModalError(message) {
      var resultado = document.getElementById("resultado");
      resultado.textContent = "";
      var errorDiv = document.createElement("div");
      errorDiv.className = "error-message";
      errorDiv.setAttribute("role", "alert");
      errorDiv.textContent = message;
      resultado.appendChild(errorDiv);
    }

    function runComparison() {
      if (stopComparison) stopComparison();
      if (fetchController) fetchController.abort();
      var run = ++comparisonGeneration;
      var generation = modalGeneration;
      var timedOut = false;
      function isCurrentRun() {
        return run === comparisonGeneration && generation === modalGeneration && modal.classList.contains("aberto");
      }
      var optionA = produtoA.options[produtoA.selectedIndex];
      var optionB = produtoB.options[produtoB.selectedIndex];

      if (!optionA || !optionB || !optionA.value || !optionB.value) {
        showModalError("Por favor, selecione os dois produtos para comparar.");
        return;
      }

      var resultado = document.getElementById("resultado");
      resultado.textContent = "";
      var spinner = document.createElement("div");
      spinner.className = "loading-spinner";
      resultado.appendChild(spinner);
      var loadingP = document.createElement("p");
      loadingP.textContent = "Preparando comparação...";
      resultado.appendChild(loadingP);

      var loadingMessages = ["Analisando produtos...", "Finalizando comparação..."];
      var messageIndex = 0;

      var loadingInterval = setInterval(function () {
        messageIndex = (messageIndex + 1) % loadingMessages.length;
        loadingP.textContent = loadingMessages[messageIndex];
      }, 3000);

      document.getElementById("summaryImgA").src = document.getElementById("imgA").src;
      document.getElementById("summaryImgB").src = document.getElementById("imgB").src;
      document.getElementById("summaryNameA").textContent =
        document.getElementById("nomeA").textContent;
      document.getElementById("summaryNameB").textContent =
        document.getElementById("nomeB").textContent;

      fetchController = new AbortController();
      // Hard timeout: backend OpenAI call timeout is 20s, plus retry budget.
      // Cap frontend at 30s so a stuck connection releases the UI eventually.
      var activeController = fetchController;
      var fetchTimeoutId = setTimeout(function () {
        if (!isCurrentRun()) return;
        timedOut = true;
        activeController.abort();
        stopComparison();
        showModalError("A comparação demorou mais que o esperado. Tente novamente.");
      }, 30000);
      stopComparison = function () {
        clearTimeout(fetchTimeoutId);
        clearInterval(loadingInterval);
      };

      Promise.all([
        fetchProductDescription(optionA, activeController.signal),
        fetchProductDescription(optionB, activeController.signal)
      ])
        .then(function (descriptions) {
          if (!isCurrentRun() || timedOut || activeController.signal.aborted) return null;
          var descA = descriptions[0];
          var descB = descriptions[1];

          if (!descA || !descB) {
            clearTimeout(fetchTimeoutId);
            clearInterval(loadingInterval);
            showModalError("Um dos produtos não possui descrição disponível para comparação.");
            return null;
          }

          var productAData = {
            id: optionA.value,
            title: optionA.text,
            description: descA,
            image: optionA.getAttribute("data-image"),
            price: optionA.getAttribute("data-price"),
            priceMinorUnits: optionA.getAttribute("data-price-minor-units") ? Number(optionA.getAttribute("data-price-minor-units")) : undefined,
            currency: optionA.getAttribute("data-currency"),
            category: optionA.getAttribute("data-category")
          };

          var productBData = {
            id: optionB.value,
            title: optionB.text,
            description: descB,
            image: optionB.getAttribute("data-image"),
            price: optionB.getAttribute("data-price"),
            priceMinorUnits: optionB.getAttribute("data-price-minor-units") ? Number(optionB.getAttribute("data-price-minor-units")) : undefined,
            currency: optionB.getAttribute("data-currency"),
            category: optionB.getAttribute("data-category")
          };

          return fetch(COMPARADOR_BASE + "/api/compare", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            signal: activeController.signal,
            body: JSON.stringify({
              productA: productAData,
              productB: productBData,
              language: "pt-br",
              domain: window.location.hostname,
              path: window.location.pathname
            })
          });
        })
        .then(function (response) {
          if (!response || !isCurrentRun() || timedOut) return null;

          if (!response.ok) {
            // Try to extract the backend's localized error message — it
            // already speaks PT-BR AND includes retry context (e.g. for
            // 429: "tente novamente em 15 minutos").
            return response.json().then(function (errorData) {
              var err = new Error("HTTP " + response.status);
              err.status = response.status;
              err.backendMessage = errorData && errorData.error;
              throw err;
            }, function () {
              var err = new Error("HTTP " + response.status);
              err.status = response.status;
              throw err;
            });
          }
          return response.json();
        })
        .then(function (data) {
          if (!data || !isCurrentRun() || timedOut) return;

          clearTimeout(fetchTimeoutId);
          clearInterval(loadingInterval);

          resultado.textContent = "";
          var comparisonEl = buildComparisonDOM(data.comparison);
          resultado.appendChild(comparisonEl);

          var verMaisContainer = document.createElement("div");
          verMaisContainer.className = "ver-mais-container";

          var titleDiv = document.createElement("div");
          titleDiv.className = "ver-mais-title";
          titleDiv.textContent = "Veja mais sobre estes produtos";
          verMaisContainer.appendChild(titleDiv);

          var buttonsDiv = document.createElement("div");
          buttonsDiv.className = "ver-mais-buttons";

          var linkA = document.createElement("a");
          linkA.href = optionA.getAttribute("data-product-url");
          linkA.className = "btn-ver-mais";
          linkA.textContent = "Ver " + optionA.text;
          buttonsDiv.appendChild(linkA);

          var linkB = document.createElement("a");
          linkB.href = optionB.getAttribute("data-product-url");
          linkB.className = "btn-ver-mais";
          linkB.textContent = "Ver " + optionB.text;
          buttonsDiv.appendChild(linkB);

          verMaisContainer.appendChild(buttonsDiv);
          resultado.appendChild(verMaisContainer);

          var step3 = document.querySelector('.step[data-step="3"]');
          if (step3) {
            step3.classList.remove("active");
            step3.classList.add("completed");
            step3.removeAttribute("aria-current");
          }

          var stepLine2 = document.querySelectorAll(".step-line")[1];
          if (stepLine2) {
            stepLine2.classList.add("completed");
          }

          resultado.scrollIntoView({ behavior: "smooth", block: "start" });
        })
        .catch(function (err) {
          clearTimeout(fetchTimeoutId);
          clearInterval(loadingInterval);
          if (!isCurrentRun() || timedOut || (err && err.name === "AbortError")) return;
          resultado.textContent = "";
          var errorDiv = document.createElement("div");
          errorDiv.className = "error-message";
          // Prefer the backend's localized error message when available;
          // it already speaks PT-BR and includes retry context.
          errorDiv.textContent = (err && err.backendMessage) ? err.backendMessage : "Ocorreu um erro ao comparar os produtos. Tente novamente.";
          resultado.appendChild(errorDiv);
        });
    }

    function clearChangedSelection(input, selectEl) {
      var selected = selectEl.options[selectEl.selectedIndex];
      if (!selected || !selected.value || input.value.toLowerCase() === selected.text.toLowerCase()) return;
      selectEl.value = "";
      selectEl.dispatchEvent(new Event("change"));
      if (input === pesquisaA) {
        produtoB.value = "";
        pesquisaB.value = "";
        produtoB.dispatchEvent(new Event("change"));
      }
    }

    // === Event Listeners ===

    [[pesquisaA, bodyDropdownA], [pesquisaB, bodyDropdownB]].forEach(function (pair) {
      pair[0].addEventListener("blur", function () {
        hideDropdown(pair[0], pair[1]);
      });
      pair[1].addEventListener("mousedown", function (event) {
        if (event.target.closest(".suggestion-item")) event.preventDefault();
      });
    });

    document.querySelector(".modal-corpo").addEventListener("scroll", function () {
      if (isLocalDropdownLayout()) {
        repositionDropdowns();
        return;
      }
      hideDropdown(pesquisaA, bodyDropdownA);
      hideDropdown(pesquisaB, bodyDropdownB);
    }, { passive: true });

    if (fecharBtn) {
      fecharBtn.addEventListener("click", fecharModal);
    }

    var backdrop = document.querySelector(".modal-backdrop");
    if (backdrop) {
      backdrop.addEventListener("click", fecharModal);
    }

    if (avancarStep1) {
      avancarStep1.addEventListener("click", function () {
        goToStep(2);
        var generation = modalGeneration;
        setTimeout(function () { if (generation === modalGeneration && currentStep === 2 && modal.classList.contains("aberto")) pesquisaB.focus(); }, 100);
      });
    }

    if (voltarStep2) {
      voltarStep2.addEventListener("click", function () {
        goToStep(1);
      });
    }

    if (avancarStep2) {
      avancarStep2.addEventListener("click", function () {
        goToStep(3);
        runComparison();
      });
    }

    if (voltarStep3) {
      voltarStep3.addEventListener("click", function () {
        goToStep(2);
      });
    }

    if (novaComparacao) {
      novaComparacao.addEventListener("click", function () {
        resetForm();
        goToStep(1);
        var generation = modalGeneration;
        setTimeout(function () { if (generation === modalGeneration && currentStep === 1 && modal.classList.contains("aberto")) pesquisaA.focus(); }, 100);
      });
    }

    if (produtoA) {
      produtoA.addEventListener("change", function () {
        var selected = this.options[this.selectedIndex];

        if (selected && selected.value) {
          var image = selected.getAttribute("data-image");
          var name = selected.text;
          selectedCategory = selected.getAttribute("data-category");
          selectedCollections = productById[selected.value] ? productById[selected.value].collections.slice() : [];

          if (produtoB.value) {
            var bOption = produtoB.options[produtoB.selectedIndex];
            if (bOption && (!productById[bOption.value] || !productById[bOption.value].collections.some(function (handle) { return selectedCollections.indexOf(handle) !== -1; }))) {
              produtoB.value = "";
              pesquisaB.value = "";
              previewB.style.display = "none";
              setButtonEnabled(avancarStep2, false);
            }
          }

          document.getElementById("imgA").src = image;
          document.getElementById("nomeA").textContent = name;
          previewA.style.display = "block";
        } else {
          previewA.style.display = "none";
          selectedCategory = "";
          selectedCollections = [];
        }

        setButtonEnabled(avancarStep1, this.value);
      });
    }

    if (produtoB) {
      produtoB.addEventListener("change", function () {
        var selected = this.options[this.selectedIndex];

        if (selected && selected.value) {
          var image = selected.getAttribute("data-image");
          var name = selected.text;
          document.getElementById("imgB").src = image;
          document.getElementById("nomeB").textContent = name;
          previewB.style.display = "block";
        } else {
          previewB.style.display = "none";
        }

        setButtonEnabled(avancarStep2, this.value);
      });
    }

    if (pesquisaA) {
      pesquisaA.addEventListener("input", function () {
        clearChangedSelection(pesquisaA, produtoA);
        debouncedShowSuggestions(pesquisaA, bodyDropdownA, produtoB.value);
      });
      pesquisaA.addEventListener("click", function () {
        showSuggestions(pesquisaA, bodyDropdownA, produtoB.value);
      });
      pesquisaA.addEventListener(
        "keydown",
        makeSearchKeydownHandler(pesquisaA, bodyDropdownA, function () { return produtoB.value; })
      );
    }

    if (pesquisaB) {
      pesquisaB.addEventListener("input", function () {
        clearChangedSelection(pesquisaB, produtoB);
        debouncedShowSuggestions(pesquisaB, bodyDropdownB, produtoA.value);
      });
      pesquisaB.addEventListener("click", function () {
        showSuggestions(pesquisaB, bodyDropdownB, produtoA.value);
      });
      pesquisaB.addEventListener(
        "keydown",
        makeSearchKeydownHandler(pesquisaB, bodyDropdownB, function () { return produtoA.value; })
      );
    }

    document.addEventListener("click", function (event) {
      if (
        (pesquisaA && pesquisaA.contains(event.target)) ||
        (pesquisaB && pesquisaB.contains(event.target)) ||
        (bodyDropdownA && bodyDropdownA.contains(event.target)) ||
        (bodyDropdownB && bodyDropdownB.contains(event.target))
      ) {
        return;
      }

      if (bodyDropdownA) bodyDropdownA.style.display = "none";
      if (bodyDropdownB) bodyDropdownB.style.display = "none";
    });

    var modalConteudo = document.querySelector(".modal-conteudo");
    if (modalConteudo) {
      modalConteudo.addEventListener("click", function (event) {
        if (
          (pesquisaA && pesquisaA.contains(event.target)) ||
          (pesquisaB && pesquisaB.contains(event.target)) ||
          (bodyDropdownA && bodyDropdownA.contains(event.target)) ||
          (bodyDropdownB && bodyDropdownB.contains(event.target))
        ) {
          return;
        }
        if (pesquisaA && bodyDropdownA) hideDropdown(pesquisaA, bodyDropdownA);
        if (pesquisaB && bodyDropdownB) hideDropdown(pesquisaB, bodyDropdownB);
        event.stopPropagation();
      });
    }

    // Focus trap: when modal is open, Tab/Shift+Tab cycles through focusable
    // elements INSIDE the modal only — preventing focus from escaping to the
    // page behind it (WCAG 2.4.3 + ARIA Authoring Practices for aria-modal).
    function getFocusableInModal() {
      if (!modal) return [];
      var sel = 'button:not([disabled]), a[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
      var nodes = modal.querySelectorAll(sel);
      var visible = [];
      for (var i = 0; i < nodes.length; i++) {
        // Skip elements inside step-content that's currently display:none
        if (nodes[i].offsetParent !== null) visible.push(nodes[i]);
      }
      return visible;
    }

    document.addEventListener("keydown", function (event) {
      if (!modal || !modal.classList.contains("aberto")) return;
      if (event.key === "Escape") {
        fecharModal();
        return;
      }
      if (event.key !== "Tab") return;
      var focusables = getFocusableInModal();
      if (!focusables.length) return;
      var index = focusables.indexOf(document.activeElement);
      var next = event.shiftKey ? index - 1 : index + 1;
      if (next < 0) next = focusables.length - 1;
      if (next >= focusables.length) next = 0;
      event.preventDefault();
      focusables[next].focus();
    });

    function repositionDropdowns() {
      if (bodyDropdownA && bodyDropdownA.style.display === "block") {
        positionDropdown(pesquisaA, bodyDropdownA);
      }
      if (bodyDropdownB && bodyDropdownB.style.display === "block") {
        positionDropdown(pesquisaB, bodyDropdownB);
      }
    }

    window.addEventListener("resize", repositionDropdowns, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", repositionDropdowns, { passive: true });
      window.visualViewport.addEventListener("scroll", repositionDropdowns, { passive: true });
    }
  });
